

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"47","height":"45","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"transform":"translate(.5)","fill":"none","fill-rule":"evenodd"}, [h('ellipse', {"fill":"#FFF","cx":"22.535","cy":"22.468","rx":"22.535","ry":"22.468"}, []), h('path', {"d":"M34.53 11.5a2 2 0 012 2v18a2 2 0 01-2 2h-24a2 2 0 01-2-2v-18a2 2 0 012-2h24zm-1.45 9h-21.1a.75.75 0 00-.75.75v8.8c0 .414.336.75.75.75h21.1a.75.75 0 00.75-.75v-8.8a.75.75 0 00-.75-.75zM13.03 14a2 2 0 100 4 2 2 0 000-4zm18 1h-14a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z","fill":"#003E99","fill-rule":"nonzero"}, [])])]);
};

        